import { render, staticRenderFns } from "./alipayInWechat.vue?vue&type=template&id=9256103e&scoped=true&"
import script from "./alipayInWechat.vue?vue&type=script&lang=js&"
export * from "./alipayInWechat.vue?vue&type=script&lang=js&"
import style0 from "./alipayInWechat.vue?vue&type=style&index=0&id=9256103e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9256103e",
  null
  
)

export default component.exports